import { Backdrop } from '@material-ui/core';
import React from 'react';
import { Loader } from './Loader';
interface LoaderBackDrop {
  loading: boolean;
  loaderMessage: string;
}
const LoaderBackDrop = (props: LoaderBackDrop) => {
  const { loading, loaderMessage } = props;
  return (
    <Backdrop style={{ zIndex: 10000 }} open={loading}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Loader text={loaderMessage} />
      </div>
    </Backdrop>
  );
};
export default LoaderBackDrop;
